<template>
  <div>
    <!--Navigation-->
    <div id="container-menu">
      <nav>
        <!--Logo-->
        <div class="container-logo">
          <img src="../../../../assets/logo_fan.png" height="90px" width="90px"/>
        </div>

        <!--List of menu-->
        <div id="container-menu-title">
          <ul>
            <!--Antigua version-->
            <li>
              <a target="_blank" rel="noopener noreferrer"
                 href="https://incendios.fan-bo.org/Satrifo/mapa-interactivo/">
                <div class="button-wrapper">
                  <img src="../../../../assets/icon-back-version.png" height="35px" width="35px"/>
                  <span class="title_item_nav">ANTERIOR VERSION</span>
                </div>
              </a>
            </li>

            <!--Capa base-->
            <li>
              <a @click="openItemMenu(0)">
                <div class="button-wrapper" id="btn-base">
                  <img src="../../../../assets/icon-capas.svg"/>
                  <span class="title_item_nav">CAPAS BASES</span>
                </div>
              </a>
            </li>

            <!--Riesgo de incendio-->
            <li>
              <a @click="openItemMenu(1)">
                <div class="button-wrapper" id="btn-riesgo">
                  <img src="../../../../assets/icon-riesgo-incendio.svg"/>
                  <span class="title_item_nav">RIESGO DE INCENDIOS</span>
                </div>
              </a>
            </li>

            <!--Focos de calor-->
            <li>
              <a @click="openItemMenu(2)">
                <div class="button-wrapper" id="btn-foco">
                  <img src="../../../../assets/icon-focos-calor.svg"/>
                  <span class="title_item_nav">FOCOS DE CALOR</span>
                </div>
              </a>
            </li>

            <!--Areas quemadas-->
            <li>
              <a @click="openItemMenu(3)">
                <div class="button-wrapper" id="btn-area">
                  <img src="../../../../assets/icon-areas-quemadas.svg"/>
                  <span class="title_item_nav">ÁREAS QUEMADAS</span>
                </div>
              </a>
            </li>

            <!--Bosques y conservacion-->
            <li>
              <a @click="openItemMenu(4)">
                <div class="button-wrapper" id="btn-bosque">
                  <img src="../../../../assets/icon-bosque-conservacion.svg"/>
                  <span class="title_item_nav">BOSQUES Y CONSERVACIÓN</span>
                </div>
              </a>
            </li>

            <!--Clima-->
            <li>
              <a @click="openItemMenu(5)">
                <div class="button-wrapper" id="btn-clima">
                  <img src="../../../../assets/icon-clima.svg"/>
                  <span class="title_item_nav">CLIMA</span>
                </div>
              </a>
            </li>

            <!--Informacion base-->
            <li>
              <a @click="openItemMenu(6)">
                <div class="button-wrapper" id="btn-info">
                  <img src="../../../../assets/icon-informacion-base.svg"/>
                  <span class="title_item_nav">INFORMACIÓN BASE</span>
                </div>
              </a>
            </li>

            <!--Mapeo y cobertura-->
            <li>
              <a @click="openItemMenu(7)">
                <div class="button-wrapper" id="btn-mapeo">
                  <img src="../../../../assets/icon-mapeo-cobertura.svg"/>
                  <span class="title_item_nav">MAPEOS Y COBERTURAS</span>
                </div>
              </a>
            </li>

            <!--Reportes-->
            <li>
              <a target="_blank" rel="noopener noreferrer" href="./reportes.html">
                <div class="button-wrapper">
                  <img src="../../../../assets/icon-reportes.svg"/>
                  <span class="title_item_nav">REPORTES</span>
                </div>
              </a>
            </li>

            <!--Mi usuario-->
            <li>
              <a @click="openItemMenu(8)">
                <div class="button-wrapper" id="btn-usuario">
                  <img src="../../../../assets/icon-alert.svg"/>
                  <span class="title_item_nav">ALERTAS</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>

    <!--Navigation container-->
    <div class='container-menu'>

      <!--Capas base-->
      <div id='lyt-capa-base' class='item'>
        <div class="container_close">
          <a style="margin: auto;" href="https://incendios.fan-bo.org/Satrifo/" target="_blank"
             rel="noopener noreferrer"><img src="../../../../assets/logo_satrifo.png"
                                            style="display: grid; margin:auto; height:60px;" alt="SATRIFO"
                                            title="SATRIFO"/></a>
          <a style="margin: 12px;" @click="closeItemMenu(0)"><img src="../../../../assets/icon-close.svg" width="16px"
                                                                  height="16px"></a>
        </div>
        <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
        <div class="content_menu_opt">
          <ul class="list-group">
            <li class="espacio_abajo"><span class="titulo_principal">Capas base</span></li>
            <li v-for="filter in filterCapasBases">
              <div v-if="filter.subcategoria === 'Capas bases'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input type="checkbox" name="switch-button" :id="`switch_id_${filter.id}`"
                           class="switch-button__checkbox"
                           @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`"
                           class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i>
                      </div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span></div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!--Riesgo de incendio-->
      <div id='lyt-riesgo-incendio' class="item">
        <div class="container_close">
          <a style="margin: auto;" href="https://incendios.fan-bo.org/Satrifo/" target="_blank"
             rel="noopener noreferrer"><img src="../../../../assets/logo_satrifo.png"
                                            style="display: grid; margin:auto; height:60px;" alt="SATRIFO"
                                            title="SATRIFO"/></a>
          <a style="margin: 12px;" @click="closeItemMenu(1)"><img src="../../../../assets/icon-close.svg" width="16px"
                                                                  height="16px"></a>
        </div>
        <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
        <div id="riesgo_content">
          <ul class="list-group1">
            <li class="espacio_abajo"><span class="titulo_principal">Futuro</span></li>
            <li v-for="filter in filterRiesgosIncendio">
              <div v-if="filter.subcategoria === 'Futuro'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input type="checkbox" name="switch-button"
                           :id="`switch_id_${filter.id}`"
                           class="switch-button__checkbox"
                           @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`"
                           class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i>
                      </div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span>
                    </div>
                  </div>
                </div>

              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Actual</span></li>
            <li v-for="filter in filterRiesgosIncendio">
              <div v-if="filter.subcategoria === 'Actual'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input type="checkbox" name="switch-button"
                           :id="`switch_id_${filter.id}`"
                           class="switch-button__checkbox"
                           @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Pasado</span></li>
            <li v-for="filter in filterRiesgosIncendio">
              <div v-if="filter.subcategoria === 'Pasado'">
                <div class="container_menu_opcion">
                  <div v-if="filter.nombre !== 'Historico'" class="switch-button">
                    <input type="checkbox" name="switch-button"
                           :id="`switch_id_${filter.id}`"
                           class="switch-button__checkbox"
                           @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`"
                           class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span>
                    </div>
                  </div>
                </div>
                <!--Show or not calendar range-->
                <template v-if="filter.nombre ==='Historico'">
                  <DatePicker :is-hidden-render="true"/>
                  <div style="text-align: center;">
                    <button type="submit" class="button is-primary"
                            @click="onClickButtonAddFilterRIHistorico(filter)">
                      Aplicar Capa
                    </button>
                  </div>
                </template>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!--Focos de calor-->
      <div id="lyt-focos-calor" class="item">
        <div class="container_close">
          <a style="margin: auto;" href="https://incendios.fan-bo.org/Satrifo/" target="_blank"
             rel="noopener noreferrer"><img src="../../../../assets/logo_satrifo.png"
                                            style="display: grid; margin:auto; height:60px;" alt="SATRIFO"
                                            title="SATRIFO"/></a>
          <a style="margin: 12px;" @click="closeItemMenu(2)"><img src="../../../../assets/icon-close.svg" width="16px"
                                                                  height="16px"></a>
        </div>
        <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">

        <div class="c-datasets">
          <div class="department-selection">
            <span class="sub-title">Seleccione un filtro</span>
            <div class="container-select">
              <v-select
                  :options="filtros"
                  v-model="selectedFiltro"
                  label="tipo_filtro"
                  :clearable="false"
                  class="select_report"
                  v-on:input="selectFiltro()">
              </v-select>
            </div>
            <div class="container-select" v-if="showSelectDepartamento">
              <v-select
                  :options="departamentos"
                  v-model="selectedDepartamento"
                  label="nombre_departamento"
                  :clearable="false"
                  class="select_report"
                  v-on:input="selectDepartamento()">
              </v-select>
              <v-select
                  v-if="showSelectMunicipios"
                  :options="municipios"
                  v-model="selectedMunicipio"
                  label="nombre_municipio"
                  :clearable="false"
                  class="select_report">
              </v-select>
            </div>
            <div class="container-select" v-if="showSelectAPNacional">
              <v-select
                  :options="apNacionales"
                  v-model="selectedAPNacional"
                  label="ap_nal"
                  :clearable="false"
                  class="select_report">
              </v-select>
            </div>
            <div class="container-select" v-if="showSelectAPSubnacional">
              <v-select
                  :options="apSubnacionales"
                  v-model="selectedAPSubnacional"
                  label="ap_sub"
                  :clearable="false"
                  class="select_report">
              </v-select>
            </div>
          </div>
        </div>

        <div id="focosCalorContainer">
          <ul class="list-group">
            <li class="espacio_abajo"><span class="titulo_principal">Eventos</span></li>
            <li v-for="filter in filterFocosCalor">
              <div v-if="filter.subcategoria === 'Eventos'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input type="checkbox" name="switch-button" :id="`switch_id_${filter.id}`"
                           class="switch-button__checkbox"
                           @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span></div>
                  </div>
                </div>
              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Actual</span></li>
            <li v-for="filter in filterFocosCalor">
              <div v-if="filter.subcategoria === 'Actual'">
                <div class="container_menu_opcion">
                  <div v-if="filter.nombre !=='Concentración por rango de fechas'" class="switch-button">
                    <input type="checkbox" name="switch-button"
                           :id="`switch_id_${filter.id}`"
                           class="switch-button__checkbox"
                           @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`"
                           class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div v-if="filter.nombre !=='Concentración por rango de fechas'" class="sugerencia"
                           @click="onClickShowDialogFilter(filter, '',true)">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item item_title_opcion_with"><span>{{ filter.descripcion }}
                    </span>
                    </div>
                  </div>
                </div>
                <!--Show or not calendar range-->
                <template v-if="filter.nombre ==='Concentración por rango de fechas'">
                  <DateTimeColorPicker :is-hidden-render="true"/>
                  <div style="text-align: center;">
                    <button type="submit" class="button is-primary"
                            @click="onClickButtonAddFilter(filter)">
                      Aplicar Capa
                    </button>
                  </div>
                </template>
              </div>
            </li>
            <li>
              <div class="container_menu_opcion">
                <div class="switch-button">
                  <input type="checkbox" name="switch-button"
                         id="showCluster"
                         class="switch-button__checkbox"
                         @click="onCheckShowCluster"
                         checked="true">
                  <label for="showCluster" class="switch-button__label"></label>
                </div>
                <div class="content">
                  <div class="header">
                    <div class="title_opt_item ">Agrupador de marcadores</div>
                  </div>
                  <div class="sub_title_menu_item item_title_opcion_with"><span>Permite habilitar y deshabilitar los marcadores</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!--Areas quemadas-->
      <div id='lyt-areas-quemadas' class="item">
        <div class="container_close">
          <a style="margin: auto;" href="https://incendios.fan-bo.org/Satrifo/" target="_blank"
             rel="noopener noreferrer"><img src="../../../../assets/logo_satrifo.png"
                                            style="display: grid; margin:auto; height:60px;" alt="SATRIFO"
                                            title="SATRIFO"/></a>
          <a style="margin: 12px;" @click="closeItemMenu(3)"><img src="../../../../assets/icon-close.svg" width="16px"
                                                                  height="16px"></a>
        </div>
        <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
        <div class="content_menu_opt">
          <ul class="list-group">
            <li class="espacio_abajo"><span class="titulo_principal">Histórico</span></li>
            <li v-for="filter in filterAreasQuemadas">
              <div v-if="filter.subcategoria === 'Histórico'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input type="checkbox" name="switch-button"
                           :id="`switch_id_${filter.id}`"
                           class="switch-button__checkbox"
                           @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!--Bosques y conservacion-->
      <div id='lyt-bosques-conservacion' class="item">
        <div class="container_close">
          <a style="margin: auto;" href="https://incendios.fan-bo.org/Satrifo/" target="_blank"
             rel="noopener noreferrer"><img src="../../../../assets/logo_satrifo.png"
                                            style="display: grid; margin:auto; height:60px;" alt="SATRIFO"
                                            title="SATRIFO"/></a>
          <a style="margin: 12px;" @click="closeItemMenu(4)"><img src="../../../../assets/icon-close.svg" width="16px"
                                                                  height="16px"></a>
        </div>
        <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
        <div class="content_menu_opt">
          <ul class="list-group">
            <li class="espacio_abajo"><span class="titulo_principal">Áreas protegidas y reserva forestal</span></li>
            <li v-for="filter in filterBosquesConservacion">
              <div v-if="filter.subcategoria === 'Áreas protegidas y reserva forestal'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input type="checkbox" name="switch-button" :id="`switch_id_${filter.id}`"
                           class="switch-button__checkbox"
                           @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span></div>
                  </div>
                </div>
              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Derechos y uso</span></li>
            <li v-for="filter in filterBosquesConservacion">
              <div v-if="filter.subcategoria === 'Derechos y uso'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input
                        type="checkbox"
                        name="switch-button"
                        :id="`switch_id_${filter.id}`"
                        class="switch-button__checkbox"
                        @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span></div>
                  </div>
                </div>
              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Deforestación</span></li>
            <li v-for="filter in filterBosquesConservacion">
              <div v-if="filter.subcategoria === 'Deforestación'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input
                        type="checkbox"
                        name="switch-button"
                        :id="`switch_id_${filter.id}`"
                        class="switch-button__checkbox"
                        @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span></div>
                  </div>
                </div>
              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Bosques</span></li>
            <li v-for="filter in filterBosquesConservacion">
              <div v-if="filter.subcategoria === 'Bosques'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input
                        type="checkbox"
                        name="switch-button"
                        :id="`switch_id_${filter.id}`"
                        class="switch-button__checkbox"
                        @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span></div>
                  </div>
                </div>
              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Biodiversidad</span></li>
            <li v-for="filter in filterBosquesConservacion">
              <div v-if="filter.subcategoria === 'Biodiversidad'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input
                        type="checkbox"
                        name="switch-button"
                        :id="`switch_id_${filter.id}`"
                        class="switch-button__checkbox"
                        @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span></div>
                  </div>
                </div>
              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Especies endémicas</span></li>
            <li v-for="filter in filterBosquesConservacion">
              <div v-if="filter.subcategoria === 'Especies endémicas'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input
                        type="checkbox"
                        name="switch-button"
                        :id="`switch_id_${filter.id}`"
                        class="switch-button__checkbox"
                        @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span></div>
                  </div>
                </div>
              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Especies en peligro</span></li>
            <li v-for="filter in filterBosquesConservacion">
              <div v-if="filter.subcategoria === 'Especies en peligro'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input
                        type="checkbox"
                        name="switch-button"
                        :id="`switch_id_${filter.id}`"
                        class="switch-button__checkbox"
                        @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter,'')">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span></div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!--Clima-->
      <div id='lyt-clima' class='item'>
        <div class="container_close">
          <a style="margin: auto;" href="https://incendios.fan-bo.org/Satrifo/" target="_blank"
             rel="noopener noreferrer"><img src="../../../../assets/logo_satrifo.png"
                                            style="display: grid; margin:auto; height:60px;" alt="SATRIFO"
                                            title="SATRIFO"/></a>
          <a style="margin: 12px;" @click="closeItemMenu(5)"><img src="../../../../assets/icon-close.svg" width="16px"
                                                                  height="16px"></a>
        </div>
        <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
        <div class="content_menu_opt">
          <ul class="list-group">
            <li class="espacio_abajo"><span class="titulo_principal">Otras capas</span></li>
            <li v-for="filter in filterClima">
              <div v-if="filter.subcategoria === 'Otras capas'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input
                        type="checkbox"
                        name="switch-button"
                        :id="`switch_id_${filter.id}`"
                        class="switch-button__checkbox"
                        @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter, '', true)">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item"><span>{{ filter.descripcion }}</span></div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!--Informacion base-->
      <div id='lyt-informacion-base' class='item'>
        <div class="container_close">
          <a style="margin: auto;" href="https://incendios.fan-bo.org/Satrifo/" target="_blank"
             rel="noopener noreferrer"><img src="../../../../assets/logo_satrifo.png"
                                            style="display: grid; margin:auto; height:60px;" alt="SATRIFO"
                                            title="SATRIFO"/></a>
          <a style="margin: 12px;" @click="closeItemMenu(6)"><img src="../../../../assets/icon-close.svg" width="16px"
                                                                  height="16px"></a>
        </div>
        <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
        <div class="content_menu_opt">
          <ul class="list-group">
            <li class="espacio_abajo"><span class="titulo_principal">Límites administrativos</span></li>
            <li v-for="filter in filterInformacion">
              <div v-if="filter.subcategoria === 'Límites administrativos'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input
                        type="checkbox"
                        name="switch-button"
                        :id="`switch_id_${filter.id}`"
                        class="switch-button__checkbox"
                        @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter, '', true)">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item item_title_opcion_with"><span>{{ filter.descripcion }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Centros poblados</span></li>
            <li v-for="filter in filterInformacion">
              <div v-if="filter.subcategoria === 'Centros poblados'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input
                        type="checkbox"
                        name="switch-button"
                        :id="`switch_id_${filter.id}`"
                        class="switch-button__checkbox"
                        @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter, '', true)">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item item_title_opcion_with"><span>{{ filter.descripcion }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Red vial</span></li>
            <li v-for="filter in filterInformacion">
              <div v-if="filter.subcategoria === 'Red vial'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input
                        type="checkbox"
                        name="switch-button"
                        :id="`switch_id_${filter.id}`"
                        class="switch-button__checkbox"
                        @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item ">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter, '', true)">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item item_title_opcion_with"><span>{{ filter.descripcion }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="espacio_abajo"><span class="titulo_principal">Hidrología</span></li>
            <li v-for="filter in filterInformacion">
              <div v-if="filter.subcategoria === 'Hidrología'">
                <div class="container_menu_opcion">
                  <div class="switch-button">
                    <input
                        type="checkbox"
                        name="switch-button"
                        :id="`switch_id_${filter.id}`"
                        class="switch-button__checkbox"
                        @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                    <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                  </div>
                  <div class="content">
                    <div class="header">
                      <div class="title_opt_item ">{{ filter.nombre }}</div>
                      <div class="sugerencia"
                           @click="onClickShowDialogFilter(filter, '', true)">
                        <i class="fas fa-exclamation-circle"></i></div>
                    </div>
                    <div class="sub_title_menu_item item_title_opcion_with"><span>{{ filter.descripcion }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
              <li class="espacio_abajo"><span class="titulo_principal">Otros</span></li>
              <li v-for="filter in filterInformacion">
                  <div v-if="filter.subcategoria === 'Hidrología'">
                      <div class="container_menu_opcion">
                          <div class="switch-button">
                              <input
                                      type="checkbox"
                                      name="switch-button"
                                      :id="`switch_id_${filter.id}`"
                                      class="switch-button__checkbox"
                                      @click="onClickSwitch(`switch_id_${filter.id}`, filter)">
                              <label :for="`switch_id_${filter.id}`" class="switch-button__label"></label>
                          </div>
                          <div class="content">
                              <div class="header">
                                  <div class="title_opt_item ">{{ filter.nombre }}</div>
                                  <div class="sugerencia"
                                       @click="onClickShowDialogFilter(filter, '', true)">
                                      <i class="fas fa-exclamation-circle"></i></div>
                              </div>
                              <div class="sub_title_menu_item item_title_opcion_with"><span>{{ filter.descripcion }}</span>
                              </div>
                          </div>
                      </div>
                  </div>
              </li>
          </ul>
        </div>
      </div>

      <!--Mapeo y cobertura-->
      <div id='lyt-mapeo-cobertura' class='item'>
        <div class="container_close">
          <a style="margin: auto;" href="https://incendios.fan-bo.org/Satrifo/" target="_blank"
             rel="noopener noreferrer"><img src="../../../../assets/logo_satrifo.png"
                                            style="display: grid; margin:auto; height:60px;" alt="SATRIFO"
                                            title="SATRIFO"/></a>
          <a style="margin: 12px;" @click="closeItemMenu(7)"><img src="../../../../assets/icon-close.svg" width="16px"
                                                                  height="16px"></a>
        </div>
        <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
        <Login v-show="showLogin"/>
        <MappingList v-show="showMappingList"/>
        <MappingABM v-show="showMappingABM" ref="dataCobertura"/>
      </div>

      <!--Mi usuario-->
      <div id='lyt-usuario' class='item'>
        <div class="container_close">
          <a style="margin: auto;" href="https://incendios.fan-bo.org/Satrifo/" target="_blank"
             rel="noopener noreferrer"><img src="../../../../assets/logo_satrifo.png"
                                            style="display: grid; margin:auto; height:60px;" alt="SATRIFO"
                                            title="SATRIFO"/></a>
          <a style="margin: 12px;" @click="closeItemMenu(8)"><img src="../../../../assets/icon-close.svg" width="16px"
                                                                  height="16px"></a>
        </div>
        <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
        <Login v-if="showLogin"/>
        <Register v-if="showRegister"/>
        <InterestSite v-if="showInterestSite"/>
      </div>

      <!--Dialog for Nav-->
      <div>
        <Modal :based-on="showModal" :title="dialogo_nombre" @close="showModal = false" class="modalshowlayer">
          <template v-if="dialogo_custom">
            <div class="p-3">
              <span class=" text-justifypt-2 pb-2 pr-2 text-dark fs-6 modalshowlayer">
            {{ dialogo_custom }}
              </span>
            </div>
          </template>
          <template v-else>
            <div class="p-3">
              <p class="text-uppercase text-secondary pb-2 font-weight-bold fs-5 modalshowlayer">Descripción</p>
              <span class="text-justify pt-2 pb-2 pr-2 text-dark fs-6 modalshowlayer">
            {{ dialogo_descripcion }}
          </span>
              <p class="text-uppercase text-secondary pb-2 pt-2 font-weight-bold fs-5 modalshowlayer">Resolucion/Tamaño
                de pixel</p>
              <span class=" text-justifypt-2 pb-2 pr-2 text-dark fs-6 modalshowlayer">
            {{ dialogo_resolucion }}
          </span>
              <p class="text-uppercase text-secondary pb-2 pt-2 font-weight-bold fs-5 modalshowlayer">Cobertura
                Geografica</p>
              <span class=" text-justify pt-2 pb-2 pr-2 text-dark fs-6 modalshowlayer">
            {{ dialogo_cobertura }}
          </span>
              <p class="text-uppercase text-secondary pb-2 pt-2 font-weight-bold fs-5 modalshowlayer">Fuente de
                Datos</p>
              <span class="text-justify pt-2 pb-2 pr-2 text-dark fs-6 modalshowlayer">
            {{ dialogo_fuente }}
          </span>
              <p class="text-uppercase text-secondary pb-2 pt-2 font-weight-bold fs-5 modalshowlayer">Frecuencia y
                Actualizaciones</p>
              <span class="text-justify pt-2 pb-2 pr-2 text-dark fs-6 modalshowlayer">
            {{ dialogo_frecuencia }}
          </span>
              <p class="text-uppercase text-secondary pb-2 pt-2 font-weight-bold fs-5 modalshowlayer">Metodologia</p>
              <span class="text-justify pt-2 pb-2 pr-2  text-dark fs-6 modalshowlayer">
            {{ dialogo_metodologia }}
          </span>
            </div>
            <div v-if="dialogo_btn_status" class="text-center">
              <a :href="dialogo_url" class="button is-primary"> Descargar</a>
            </div>
          </template>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "@/components/main/login/Login";
import Register from "@/components/main/login/Register";
import InterestSite from "@/components/main/login/SitiosInteres";
import DateTimeColorPicker from "@/components/main/dialog/DialogDateTimeColorPicker";
import DatePicker from "@/components/main/dialog/DialogDatePicker";
import MappingList from "@/components/main/mapping/MappingList";
import MappingABM from "@/components/main/mapping/MappingABM";
import axios from "axios";
import {v4 as uuidv4} from 'uuid';

import VueModal from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'

import {config} from '@/config.json'
import jsonDepartamentosMunicipios from "@/helpers/departamentos-municipios.json";
import firebase from "firebase";
import * as Utils from "@/helpers/utils";
import * as LocalStorage from "@/helpers/localstorage";

export default {
  components: {
    Login,
    Register,
    DateTimeColorPicker,
    DatePicker,
    InterestSite,
    MappingList,
    MappingABM,
    'Modal': VueModal
  },
  data() {
    return {
      /**
       * ids for html (header and body for nav)
       * */
      layers: ['lyt-capa-base', 'lyt-riesgo-incendio', 'lyt-focos-calor', 'lyt-areas-quemadas', 'lyt-bosques-conservacion', 'lyt-clima', 'lyt-informacion-base', 'lyt-mapeo-cobertura', 'lyt-usuario'],
      buttons: ['btn-base', 'btn-riesgo', 'btn-foco', 'btn-area', 'btn-bosque', 'btn-clima', 'btn-info', 'btn-mapeo', 'btn-usuario'],

      /**
       * select values
       * */
      filtros: [
        {"id": 1, "tipo_filtro": "Departamental"},
        {"id": 2, "tipo_filtro": "Áreas Protegidas Nacional"},
        {"id": 3, "tipo_filtro": "Áreas Protegidas SubNacional"}
      ],
      departamentos: [],
      municipios: [],
      apNacionales: [],
      apSubnacionales: [],

      /**
       * show selector
       * */
      showSelectDepartamento: false,
      showSelectMunicipios: false,
      showSelectAPNacional: false,
      showSelectAPSubnacional: false,

      /**
       * selected item
       * */
      selectedFiltro: {"tipo_filtro": "Seleccionar un filtro"},
      selectedDepartamento: {"codigo_departamento": "0", "nombre_departamento": "Seleccione un departamento"},
      selectedMunicipio: {"codigo_municipio": "0", "nombre_municipio": "Seleccione un municipio"},
      selectedAPNacional: {"idap_nal": "0", "ap_nal": "Seleccione una área protegida nacional"},
      selectedAPSubnacional: {"codigo_ap_sub": "0", "ap_sub": "Seleccione una área protegida nacional"},

      /**
       * filter arrays
       * */
      filterCapasBases: [],
      filterRiesgosIncendio: [],
      filterFocosCalor: [],
      filterAreasQuemadas: [],
      filterBosquesConservacion: [],
      filterClima: [],
      filterInformacion: '',

      showLogin: false,
      showRegister: false,
      showInterestSite: false,
      showMappingList: false,
      showMappingABM: false,

      showCluster: true,
      showModal: false,
      dialogo_nombre: "",
      dialogo_subcategoria: "",
      dialogo_descripcion: "",
      dialogo_resolucion: "",
      dialogo_cobertura: "",
      dialogo_fuente: "",
      dialogo_frecuencia: "",
      dialogo_metodologia: "",
      dialogo_custom: "",
      dialogo_url: "",
      dialogo_btn_status: false,
    }
  },
  methods: {
    /**
     * Initialization all filter
     * */
    async getAllFilter() {
      let self = this;

      self.$root.$emit("app-show-loading", true);

      const promiseAPNal = axios.get(`${config.api.baseURL}/obtenerSitiosInteresAPNacionalWeb`);
      const promiseAPSub = axios.get(`${config.api.baseURL}/obtenerSitiosInteresAPSubNacionalWeb`);
      const promiseFilter = axios.get(`${config.api.baseURL}/obtenerFiltrosWeb`);

      Promise
          .all([promiseAPNal, promiseAPSub, promiseFilter])
          .then(function (values) {
            //load departaments
            self.departamentos = self.loadJsonDepartamentos();
            //load area protected
            self.apNacionales = JSON.parse(values[0].data.jsonCompleto);
            self.apSubnacionales = JSON.parse(values[1].data.jsonCompleto);
            //load all filter
            let data = JSON.parse(values[2].data.jsonCompleto);
            self.filterCapasBases = self.searchFilterByCategory(data, 'Capas bases');
            self.filterRiesgosIncendio = self.searchFilterByCategory(data, 'Riesgo de incendios');
            self.filterFocosCalor = self.searchFilterByCategory(data, 'Focos de calor');
            self.filterAreasQuemadas = self.searchFilterByCategory(data, 'Areas quemadas');
            self.filterBosquesConservacion = self.searchFilterByCategory(data, 'Bosques y conservación');
            self.filterClima = self.searchFilterByCategory(data, 'Clima');
            self.filterInformacion = self.searchFilterByCategory(data, 'Información base');
          })
          .finally(function () {
            self.$root.$emit("app-show-loading", false);

            //cargar focos de calor de 24hr
            if (document.getElementById("switch_id_12")) {
              document.getElementById('switch_id_12').click();
            }
          });
    },
    searchFilterByCategory(filters, category) {
      return filters.filter((filter) => {
        if (filter.categoria === category) {
          return filter;
        }
      })
    },

    /**
     * Nav events
     * */
    openItemMenu(index) {
      let element = document.querySelector('#' + this.layers[index]);
      let button = document.querySelector('#' + this.buttons[index]);
      let legenda = document.querySelector("#container_legenda");

      if (element.classList.contains('activeitem')) {
        element.classList.remove('activeitem');
        button.classList.remove('btn-active');
        legenda.classList.remove('changepositionlegenda');
      } else {
        element.classList.add('activeitem');
        button.classList.add('btn-active');
        legenda.classList.add('changepositionlegenda');
        this.closeAllItemMenuExceptSelected(index);
      }
    },
    closeItemMenu(index) {
      //this element is Legend.vue component
      let legend = document.querySelector('#container_legenda');
      let navBody = document.querySelector('#' + this.layers[index]);
      let navButton = document.querySelector('#' + this.buttons[index]);

      navBody.classList.remove('activeitem');
      navButton.classList.remove('btn-active');
      legend.classList.remove('changepositionlegenda');
    },
    closeAllItemMenuExceptSelected(indexSelected) {
      let layersCopy = this.layers.slice();
      let buttonsCopy = this.buttons.slice();

      layersCopy.splice(indexSelected, 1);
      buttonsCopy.splice(indexSelected, 1);

      for (let i = 0; i < layersCopy.length; i++) {
        let element = document.querySelector('#' + layersCopy[i]);
        let button = document.querySelector('#' + buttonsCopy[i]);
        element.classList.remove('activeitem');
        button.classList.remove('btn-active');
      }
    },

    /**
     * load Departamento and Municipio from JSON
     * */
    loadJsonDepartamentos() {
      return jsonDepartamentosMunicipios.filter(function (item) {
        return item.codigo_municipio === '0';
      });
    },
    loadJsonMunicipios(id_departamento) {
      return jsonDepartamentosMunicipios.filter(function (item) {
        return item.codigo_departamento === id_departamento && item.codigo_municipio > 0
      });
    },

    /**
     * Select event
     * */
    selectFiltro() {
      this.showSelectDepartamento = this.selectedFiltro.id === 1;
      this.showSelectAPNacional = this.selectedFiltro.id === 2;
      this.showSelectAPSubnacional = this.selectedFiltro.id === 3;
      this.resetSelector();
    },
    selectDepartamento() {
      this.showSelectMunicipios = true;
      this.resetSelector();
      this.municipios = this.loadJsonMunicipios(this.selectedDepartamento.codigo_departamento);
    },
    resetSelector() {
      if (this.selectedFiltro.id === 1) {
        this.selectedMunicipio = {"codigo_municipio": "0", "nombre_municipio": "Seleccione un municipio"};
      } else {
        this.selectedDepartamento = {"codigo_departamento": "0", "nombre_departamento": "Seleccione un departamento"};
        this.selectedMunicipio = {"codigo_municipio": "0", "nombre_municipio": "Seleccione un municipio"};
        this.selectedAPNacional = {"idap_nal": "0", "ap_nal": "Seleccione una área protegida nacional"};
        this.selectedAPSubnacional = {"codigo_ap_sub": "0", "ap_sub": "Seleccione una área protegida nacional"};
      }
    },
    signOut() {
      let self = this;
      firebase.auth().signOut().then(function() {
        LocalStorage.clean();
        self.showLogin = true;
        self.showRegister = false;
        self.showInterestSite = false;

        let btnMapeoMenu = document.getElementById("btn-mapeo");
        let btnUsuarioMenu = document.getElementById("btn-usuario");
        btnMapeoMenu.classList.add("disabled");
        btnUsuarioMenu.classList.add("disabled");
      }, function(error) {
        console.error('Sign Out Error', error);
      });
    },
    onClickSwitch(key, filter) {
      let checkbox = document.getElementById(key);
      if (checkbox.checked) {

        //add init and final for FC date
        if(filter.categoria == "Focos de calor" && filter.subcategoria == "Actual") {
          filter.init = Utils.getDateUTC();
          filter.final = Utils.getDateUTC();
          filter.init.setHours(filter.init.getHours() - filter.fecha);
        }

        //add filter in legend.vue
        this.$root.$emit("legend-add-in-filters", filter);

        //load filter in map.vue
        this.addFilterInMap(filter);
      } else {
        //remove filter in legend.vue
        this.$root.$emit("legend-remove-in-filters", filter);

        //remove filter in map.vue
        this.removeFilterInMap(filter);
      }
    },
    onClickButtonAddFilter(filter) {
      let filterClone = JSON.parse(JSON.stringify(filter));
      filterClone.id = uuidv4();
      let initialDate = document.querySelector('#startDate').value;
      let finalDate = document.querySelector('#endDate').value;
      let colorMarker = document.querySelector('#color-marker').value;

      if (initialDate === undefined || initialDate === '' ||
          finalDate === undefined || finalDate === '' ||
          colorMarker === undefined || colorMarker === '') {
        return;
      }

      filterClone.init = initialDate;
      filterClone.final = finalDate;
      filterClone.color = colorMarker.replace('#','');

      //add filter in legend.vue
      this.$root.$emit("legend-add-in-filters", filterClone);

      //load filter in map.vue
      this.addFilterInMap(filterClone);
    },
    onClickButtonAddFilterRIHistorico(filter) {
      let self = this;
      let filterClone = JSON.parse(JSON.stringify(filter));
      filterClone.id = uuidv4();

      let date = document.querySelector('#selectedDate').value;
      if (date === undefined || date === '') {
        return;
      }

      self.$root.$emit("app-show-loading", true);
      axios.post(`${config.api.baseURL}/sincronizarRiesgoIncedioHistorico/${date}`)
          .then(function (response) {
            self.$root.$emit("app-show-loading", false);

            //add filter in legend.vue, and concat date in description
            filterClone.descripcion += " " + date;
            self.$root.$emit("legend-add-in-filters", filterClone);

            //load filter in map.vue
            self.addFilterInMap(filterClone);
          });
    },
    onClickSwitchDisableFromLegend(key, filter) {
      let checkbox = document.getElementById(key);
      if (checkbox !== null) {
        checkbox.checked = false;
      }
      //remove filter in map.vue
      this.removeFilterInMap(filter);
    },
    addFilterInMap(filter) {
      let selectedFiltroId = this.selectedFiltro.id == undefined ? 1 : this.selectedFiltro.id;
      if (filter.formato_web === "KMZ") {
        this.$root.$emit("map-load-kmz", filter);
      } else if (filter.formato_web === "WMS") {
        this.$root.$emit("map-load-wms", filter);
      } else if (filter.formato_web === "API_FOCO") {
        this.$root.$emit("map-load-api_foco", filter, selectedFiltroId, this.selectedDepartamento.codigo_departamento, this.selectedMunicipio.codigo_municipio, this.selectedAPNacional.idap_nal, this.selectedAPSubnacional.codigo_ap_sub);
      } else if (filter.formato_web === "API_FOCO_RANGO") {
        this.$root.$emit("map-load-api_foco_range", filter, selectedFiltroId, this.selectedDepartamento.codigo_departamento, this.selectedMunicipio.codigo_municipio, this.selectedAPNacional.idap_nal, this.selectedAPSubnacional.codigo_ap_sub);
      }
    },
    removeFilterInMap(filter) {
      if (filter.formato_web === "KMZ") {
        this.$root.$emit("map-remove-kmz", filter);
      } else if (filter.formato_web === "WMS") {
        this.$root.$emit("map-remove-wms", filter);
      } else if (filter.formato_web === "API_FOCO") {
        this.$root.$emit("map-remove-api_foco", filter);
      } else if (filter.formato_web === "API_FOCO_RANGO") {
        this.$root.$emit("map-remove-api_foco_range", filter);
      }
    },
    onClickShowDialogFilter(filter, customContent) {
      this.dialogo_nombre = filter.nombre.trim();
      this.dialogo_subcategoria = filter.subcategoria.trim();
      this.dialogo_descripcion = filter.descripcion.trim();
      this.dialogo_resolucion = filter.hasOwnProperty('dialogo_resolucion') ? filter.dialogo_resolucion.trim() : "-";
      this.dialogo_cobertura = filter.hasOwnProperty('dialogo_cobertura') ? filter.dialogo_cobertura.trim() : "-";
      this.dialogo_fuente = filter.hasOwnProperty('dialogo_fuente') ? filter.dialogo_fuente.trim() : "-";
      this.dialogo_frecuencia = filter.hasOwnProperty('dialogo_frecuencia') ? filter.dialogo_frecuencia.trim() : "-";
      this.dialogo_metodologia = filter.hasOwnProperty('dialogo_metodologia') ? filter.dialogo_metodologia.trim() : "-";
      this.dialogo_custom = customContent;

      if(!filter.hasOwnProperty('dialogo_descarga') || filter.dialogo_descarga.length <= 0 || this.showLogin) {
        this.dialogo_btn_status = false;
      } else {
        if(filter.dialogo_descarga.includes("Focos")) {
          let url = filter.dialogo_descarga;
          filter.init = new Date(filter.init);
          filter.final = new Date(filter.final);
          filter.init.setDate(filter.final.getDate() - 7);
          url = url.replace("MES", Utils.formatDate(filter.final, "MM"));
          url = url.replace("YYYYMMDD1", Utils.formatDate(filter.init, "yyyyMMdd"));
          url = url.replace("YYYYMMDD2", Utils.formatDate(filter.final, "yyyyMMdd"));
          this.dialogo_url = url;
        } else {
          this.dialogo_url = filter.dialogo_descarga;
        }
        this.dialogo_btn_status = true;
      }
      this.showModal = true;
    },
    onCheckShowCluster() {
      this.showCluster = !this.showCluster;
      let show = this.showCluster;
      this.$root.$emit("map-show-cluster", show);
    },
    async viewLoginForm() {
      this.showLogin = true;
      this.showRegister = false;
      this.showInterestSite = false;
      this.showMappingList = false;
      this.showMappingABM = false;

      let btnMapeoMenu = document.getElementById("btn-mapeo");
      let btnUsuarioMenu = document.getElementById("btn-usuario");
      btnMapeoMenu.classList.add("disabled");
      btnUsuarioMenu.classList.add("disabled");
    },
    async viewRegisterForm() {
      this.showLogin = false;
      this.showRegister = true;
      this.showInterestSite = false;
      this.showMappingList = false;
      this.showMappingABM = false;
    },
    async viewInterestSiteForm() {
      this.showLogin = false;
      this.showRegister = false;
      this.showInterestSite = true;
      this.showMappingList = false;
      this.showMappingABM = false;
      this.$root.$emit("sitios-interes-load-data", {});

      let btnMapeoMenu = document.getElementById("btn-mapeo");
      let btnUsuarioMenu = document.getElementById("btn-usuario");
      btnMapeoMenu.classList.remove("disabled");
      btnUsuarioMenu.classList.remove("disabled");
    },
    async viewMappingListForm() {
      this.showLogin = false;
      this.showRegister = false;
      this.showMappingList = true;
      this.showMappingABM = false;
      this.$root.$emit("mapping-list-load-data", {});

      let btnMapeoMenu = document.getElementById("btn-mapeo");
      let btnUsuarioMenu = document.getElementById("btn-usuario");
      btnMapeoMenu.classList.remove("disabled");
      btnUsuarioMenu.classList.remove("disabled");
    },
    viewMappingABMForm(item) {
      this.showLogin = false;
      this.showRegister = false;
      this.showMappingList = false;
      this.showMappingABM = true;
      this.$root.$emit("mapping-abm-load-data", { mapping: item.item });
    },
  },
  mounted() {
    let self = this;
    firebase
        .auth()
        .onAuthStateChanged(async (user) => {
          await self.getAllFilter();
          if (!user) {
            await self.viewLoginForm();
          } else {
            if(LocalStorage.getUserId() === null) {
              self.signOut();
            } else {
              await self.viewInterestSiteForm();
              await self.viewMappingListForm();
            }
          }
        });
  },
  created() {
    this.$root.$on("navresponsive-show-login", this.viewLoginForm);
    this.$root.$on("navresponsive-show-register", this.viewRegisterForm);
    this.$root.$on("navresponsive-show-interest-site", this.viewInterestSiteForm);
    this.$root.$on("navresponsive-show-mapping-list", this.viewMappingListForm);
    this.$root.$on("navresponsive-show-mapping-abm", this.viewMappingABMForm);

    this.$root.$on("navresponsive-signout", this.signOut);
    this.$root.$on("nav-onclick-switch-disable", this.onClickSwitchDisableFromLegend);
    this.$root.$on("nav-onclick-show-dialog-filter", this.onClickShowDialogFilter);
  },
  beforeDestroy() {
    this.$root.$off("navresponsive-show-login", this.viewLoginForm);
    this.$root.$off("navresponsive-show-register", this.viewRegisterForm);
    this.$root.$off("navresponsive-show-interest-site", this.viewInterestSiteForm);
    this.$root.$off("navresponsive-show-mapping-list", this.viewMappingListForm);
    this.$root.$off("navresponsive-show-mapping-abm", this.viewMappingABMForm);

    this.$root.$off("navresponsive-signout", this.signOut);
    this.$root.$off("nav-onclick-switch-disable", this.onClickSwitchDisableFromLegend);
    this.$root.$off("nav-onclick-show-dialog-filter", this.onClickShowDialogFilter);
  }
}

</script>

<style scoped lang="scss">

.container-menu {
  background: transparent;
  min-height: 100vh;
  font-family: Montserrat, sans-serif;
  width: 40%;
}

.container-menu .close-menu {
  position: absolute;
  top: 0;
  right: 0;
  padding: .9375rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  cursor: pointer;
  z-index: 6;
}

.c-datasets {
  height: auto;
}

.c-datasets .department-selection {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.25rem;
  padding: 10px 10px 0 10px;
}

.c-datasets .department-selection .sub-title {
  text-transform: uppercase;
  font-size: 14px;
  color: #4a4a4a;
  margin-bottom: .3125rem;
  font-weight: bold;
}

.c-datasets .department-selection .container-select {
  display: flex;
  flex-wrap: wrap;
}

.c-datasets .department-selection .container-select .select_report {
  margin-top: 5px;
  color: #9e9e9e !important;
  letter-spacing: -0.3px;
  width: 100%;
  font-size: 12px;
}

.container-logo {
  text-align: center;
  background: #ffffff;
  display: flex;
  justify-content: center;
}

#container-menu-title {
  display: flex;
  line-height: 17px;
  text-align: center;
  text-decoration: none;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  height: 100%;
  background: #f2f2f2;
}

#container-menu-title::-webkit-scrollbar {
  background: #fff;
  width: 5px;
  height: 15px;
}

#container-menu-title::-webkit-scrollbar-thumb {
  background: #c5c5c5;
}

#container-menu-title {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.container-item-filter {
  display: flex;
  margin-bottom: 1.25rem;
}

.switch-button {
  display: flex;
  margin-top: 5px;
}

.switch-button .switch-button__checkbox {
  display: none;
}

.txt-title {
  color: #4a4a4a;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
  text-transform: uppercase;
  margin-bottom: 5px;
}


.modalshowlayer {
  font-family: Montserrat, sans-serif !important;
}

.item_title_opcion_with {
  width: 90% !important;
}

.sugerencia {
  color: #cccccc;
  height: 100%;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 100%;
}

.espacio_abajo {
  margin-bottom: 10px;
}

.titulo_principal {
  color: #4a4a4a;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.title_opt_item {
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: -0.3px;
  color: #555;
  padding-left: .375rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.title_menu_item {
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: -0.3px;
  color: #555;
  margin-top: -2px;
  padding-left: 0.375rem;
  cursor: pointer;
}

.sub_title_menu_item {
  font-size: 12px;
  letter-spacing: -0.3px;
  color: #9e9e9e;
  line-height: 1.5;
  max-width: calc(100% - 20px);
  padding-left: 0.375rem;
  word-break: break-word;
}

#riesgo_content {
  padding: 15px;
  overflow-y: auto;
}

.content_menu_opt {
  padding: 15px;
  position: relative;
}

.close {
  z-index: 15;
}

.containner_opcion_menu {
  display: flex;
  margin-bottom: 1.25rem;
  flex-direction: column;
}

.container_menu_opcion {
  display: flex;
  margin-bottom: 1.25rem;
}

.changepositionlegenda {
  transform: translateX(305px);
  animation: 2s fadeIn forwards .5s;
}

.btn-active {
  background: #FFFFFF;
}

.active {
  display: none !important;
}

.activebackground {
  background: #FFFFFF none repeat scroll 0% 0% !important;
  height: 80px;
}

nav ul li a {
  font-size: 40px;
  color: #34495e;
  text-decoration: none;
  text-align: center;
}

nav {
  position: absolute;
  left: 0;
  z-index: 50;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  height: 100%;
  background: var(--secondary-color);
}

.item {
  display: flex;
  position: absolute;
  top: 0;
  height: 100%;
  width: 0;
  opacity: 0;
  transition: all ease-in .5s;
  flex-direction: column;
  overflow-y: auto;
}

.item h1 {
  bottom: 0;
  top: 0;
  border-radius: 0;
  padding-left: 0.625rem;
  animation: 2s fadeIn forwards .5s;
}

/* Styles applied on trigger */
/*.item:target {*/
/*    opacity: 1;*/
/*    position: absolute;*/
/*    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);*/
/*    left: 4%;*/
/*    width: 15%;*/
/*    z-index: 10;*/
/*    background: #FFF;*/
/*    animation: 2s fadeIn forwards .5s;*/
/*}*/

/*.item :target h1 {*/
/*    opacity: 0;*/
/*    animation: 2s fadeIn forwards .5s;*/
/*}*/

.activeitem {
  opacity: 1;
  position: absolute;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);
  left: 5.6rem;
  width: 18.75rem;
  z-index: 10;
  background: #FFF;
  animation: 2s fadeIn forwards .5s;
}

.activeitem h1 {
  opacity: 0;
  transition: transform 0.3s linear;
}

#container_logo {
  background: #f2f2f2;
  flex-direction: row;
}

//#contenedor_menu ul {
//  list-style: none;
//}

.button-wrapper {
  height: 4.80rem;
  width: 90px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;
  padding: 5px;
  overflow: hidden;
  font-size: 1.60rem;
}

.title_item_nav {
  font-size: 0.65rem;
  color: #212121;
}

#third {
  background: #FFFFFF;
}

.title_item_nav {
  font-size: 10px;
  color: #4a4a4a;
  display: flex;
  justify-content: center;
  line-height: 1.5;
  letter-spacing: -0.2px;
  position: relative;
  align-content: center;
  text-transform: uppercase;
}

ul li .button-wrapper:hover {
  background: #FFFFFF;
}

ul li .button-wrapper:target {
  background: #FFFFFF;
}

.close {
  text-decoration: none;
  color: #4a4a54;
  text-align: right;
  padding: 5px;
  margin-right: 5px;
}

#riesgo {
  text-align: center;
  color: #fc3c26;
  font-size: 2rem;
  border-bottom: 3px solid #fc3c26;
  padding-bottom: 5px;
}

#riesgo h1 {
  text-align: center;
  color: #fc3c26;
  font-size: 0.90rem;
}

#focoscalortitulo {
  text-align: center;
  color: #f2b257;
  font-size: 2rem;
  border-bottom: 3px solid #f2b257;
  padding-bottom: 5px;
}

#focoscalortitulo h1 {
  text-align: center;
  color: #f2b257;
  font-size: 0.90rem;
}

#areaQuemadatitulo {
  text-align: center;
  color: #c98e6c;
  font-size: 2rem;
  border-bottom: 3px solid #c98e6c;
  padding-bottom: 5px;
}

#areaQuemadatitulo h1 {
  text-align: center;
  color: #c98e6c;
  font-size: 0.90rem;
}

#bosquestitulo {
  text-align: center;
  color: #b2d26e;
  font-size: 2rem;
  border-bottom: 3px solid #b2d26e;
  padding-bottom: 5px;
}

#bosquestitulo h1 {
  text-align: center;
  color: #b2d26e;
  font-size: 0.90rem;
}

#climatitulo {
  text-align: center;
  color: #3182bd;
  font-size: 2rem;
  border-bottom: 3px solid #3182bd;
  padding-bottom: 5px;
}

#climatitulo h1 {
  text-align: center;
  color: #3182bd;
  font-size: 0.90rem;
  margin-left: -24px;
}

#imformaciontitulo {
  text-align: center;
  color: #ff6699;
  font-size: 2rem;
  border-bottom: 3px solid #ff6699;
  padding-bottom: 5px;
}

#imformaciontitulo h1 {
  text-align: center;
  color: #ff6699;
  font-size: 0.90rem;
  margin-left: -24px;
}

#focosCalorContainer {
  padding: 10px;
}

.switch-button {
  display: flex;
  margin-top: 5px;
}

.content {
  flex: 1 1;
}

.header {
  display: flex;
  justify-content: space-between;
}

.switch-button .switch-button__label {
  background-color: #FFFFFF !important;
  width: 1.50rem;
  height: 0.80rem;
  border-radius: 3rem;
  display: flex;
  position: relative;
  box-shadow: inset 0px 0px 0px 1px #dfdfdf;
}

.switch-button .switch-button__label:before {
  transition: .2s;
  display: block;
  position: absolute;
  width: 0.80rem;
  height: 0.80rem;
  background-color: #FFFFFF;
  content: '';
  border-radius: 50%;
  box-shadow: inset 0px 0px 0px 1px #CCC;
}

.switch-button .switch-button__checkbox:checked + .switch-button__label {
  background-color: #47da5d !important;
}

.switch-button .switch-button__checkbox:checked + .switch-button__label:before {
  transform: translateX(0.7rem);
  height: 0.80rem;
}

.button.is-primary {
  background-color: #106129 !important;
  width: 50%;
  color: #fff;
  padding-right: 5px;
  padding-left: 5px;
  margin-bottom: 10px;
  font-size: 0.70rem;
}

.button.is-primary:hover, .button.is-primary.is-hovered {
  background-color: #106129 !important;
  border-color: transparent;
  color: #fff;
}

.container_close {
  display: grid;
  grid-template-columns: 1fr .15fr;
  grid-gap: 10px;
  width: 100%;
  min-height: 70px;
}

.footer-app {
  background: #ffffff;
  display: flex;
  flex-direction: row;
  z-index: 20;
  position: absolute;
  bottom: 1.6rem;
  top: auto;
  left: 4rem;
  font-size: 1rem;
  height: 35px;
}

.disabled {
  background: slategray;
}

@keyframes fadeIn {
  100% {
    opacity: 1
  }
}

@media screen and (max-width: 759px) {
  nav {
    background: transparent !important;

    .listaOpcionCuenta {
      display: none;
    }

    .listaOpcionMenu {
      display: none;
    }

    figure {
      background: #f2f2f2;
    }
  }
  .navmobile {
    display: block;
  }
}

/* Custom, iPhone Retina */
@media only screen and (min-width: 320px) {

}

/* Extra Small Devices, Phones */
@media only screen and (min-width: 480px) {

}

/* Small Devices, Tablets */
@media only screen and (min-width: 768px) {
  .activeitem {
    left: 5.6rem;
    width: 18.75rem;
  }
}

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {
  .activeitem {
    left: 5.6rem;
    width: 18.75rem;
  }
}


@media only screen and (min-width: 992px) {
  .activeitem {
    left: 5.6rem;
    width: 18.75rem;
  }
}

@media only screen and (min-width: 1024px) {
  .activeitem {
    left: 5.6rem;
    width: 18.75rem;
  }

}

/* Large Devices, Wide Screens */
@media only screen and (min-width: 1280px) {
  .activeitem {
    left: 5.6rem;
    width: 18.75rem;
  }
  #focosCalorContainer {
    padding: 20px;
  }
}

@media only screen and (min-width: 1366px) {
  .activeitem {
    left: 5.6rem;
    width: 18.75rem;
  }
  #focosCalorContainer {
    padding: 20px;
  }
}

@media only screen and (min-width: 1440px) {
  .activeitem {
    left: 5.6rem;
    width: 18.75rem;
  }
  #focosCalorContainer {
    padding: 20px;
  }
}

@media only screen and (min-width: 1600px) {
  .activeitem {
    left: 5.6rem;
    width: 18.75rem;
  }

}

@media only screen and (min-width: 1920px) {
  .activeitem {
    left: 5.6rem;
    width: 18.75rem;
  }
  #focosCalorContainer {
    padding: 15px;
  }
}

@media only screen and (min-width: 2560px) {
  .activeitem {
    left: 5.6rem;
    width: 18.75rem;
  }
  #focosCalorContainer {
    padding: 15px;
  }
}
</style>